import { render, staticRenderFns } from "./warnings.vue?vue&type=template&id=e5338ea0&scoped=true"
import script from "./warnings.vue?vue&type=script&lang=js"
export * from "./warnings.vue?vue&type=script&lang=js"
import style0 from "./warnings.vue?vue&type=style&index=0&id=e5338ea0&prod&lang=scss&scoped=true"
import style1 from "./warnings.vue?vue&type=style&index=1&id=e5338ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5338ea0",
  null
  
)

export default component.exports